import React from 'react';
import Icon from '../../../components/AppIcon';

const ServiceStatusCard = ({ service }) => {
  const getStatusConfig = (status) => {
    switch (status) {
      case 'healthy': return { icon: 'CheckCircle', color: 'text-success', bg: 'bg-success/10' };
      case 'degraded': return { icon: 'AlertTriangle', color: 'text-warning', bg: 'bg-warning/10' };
      case 'error': return { icon: 'XCircle', color: 'text-destructive', bg: 'bg-destructive/10' };
      case 'not_configured': return { icon: 'Settings', color: 'text-muted-foreground', bg: 'bg-muted' };
      default: return { icon: 'Activity', color: 'text-muted-foreground', bg: 'bg-muted' };
    }
  };

  const config = getStatusConfig(service?.status);

  return (
    <div className="bg-card border border-border rounded-lg p-4 shadow-elevation-1">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-sm font-semibold text-foreground capitalize">{service?.name}</h3>
        <div className={`p-1.5 rounded-lg ${config?.bg}`}>
          <Icon name={config?.icon} size={16} className={config?.color} />
        </div>
      </div>
      <p className="text-xs text-muted-foreground">{service?.message || 'No status available'}</p>
      {service?.latency && (
        <p className="text-xs text-muted-foreground mt-1">Latency: {service?.latency}ms</p>
      )}
    </div>
  );
};

export default ServiceStatusCard;